// extracted by mini-css-extract-plugin
export default {"placeholder":"empty-placeholder_placeholder__hnJ6K","title":"empty-placeholder_title__+8gmF","recommendation":"empty-placeholder_recommendation__N7Hxx"};